//设置记录请求列表
export default {
	requests:[]
};